// import Vue from 'vue'
// import Vuex from 'vuex'
import _ from 'lodash'

import actions from './actions'
import mutations from './mutations'

import { createStore } from 'g-public/vuex'

export function generatorGetters(state) {
    let getters = {}
    if (_.isObject(state)) return {}
    for (let key in state) {
        if (state.hasOwnProperty(key)) {
            let name = key.replace(/([A-Z])/g, '_$1').toUpperCase()
            getters[name] = function(state) {
                return state[key]
            }
        }
    }
    return getters
}

const state = {
    ver: {},
    banners: [],
    bannersResourceId: '',
    bannersErrorInfo: {}
}

const getters = generatorGetters(state)


// Vue.use(Vuex)

// const createStore = () => (new Vuex.Store({
//     state:,
//     getters: generatorGetters(state),
//     actions: actions,
//     mutations: mutations
// }))

// export default createStore

export default {
    state, getters, actions, mutations
}